/* Deterministic, explainable draft rules. No requests, tracking or DOM work. */
(function (root) {
  'use strict';
  const aliases = {
    animals: ['animals', 'animals & wildlife', 'wildlife', 'dogs', 'cats', 'birds'],
    nature: ['floral', 'flowers & floral', 'flowers', 'nature', 'nature & landscapes', 'landscapes'],
    fantasy: ['fantasy', 'fantasy & mystical', 'fantasy and mystical', 'dragons', 'fairies'],
    characters: ['licensed brands', 'disney', 'marvel', 'dc', 'harry potter', 'sanrio', 'peanuts'],
    seasonal: ['christmas', 'halloween', 'holidays', 'easter', 'thanksgiving'],
    meaningful: ['spirituality & religion', 'spirituality', 'religion', 'love & romance', 'love', 'romance'],
    variety: ['variety', 'abstract', 'patterns', 'mandala', 'mandalas']
  };
  function styles(product) {
    const normalize=t=>t.toLowerCase().replace(/^category\d*:\s*/, '').replace(/[®™]/g,'').replace(/\s+(?:and|\+|&)\s+/g,' & ').trim();
    const tags = (product.tags || []).map(normalize);
    return Object.keys(aliases).filter(key => aliases[key].some(tag => tags.includes(normalize(tag))));
  }
  function catalogScope(answers) {
    return answers.experience === 'regular' || ['canvas_all','craft'].includes(answers.format) ? 'all' : 'starter';
  }
  function formatMatch(product, format) {
    if (!format || format === 'any') return true;
    if (format === 'canvas_all') return product.format === 'canvas';
    if (format === 'canvas') return product.format === 'canvas' && product.starter === true;
    return product.format === format;
  }
  function hardMatch(product, answers, currency) {
    return (catalogScope(answers) === 'all' || product.starter === true) && product.currency === currency && Number.isFinite(product.price) && product.price >= 0 &&
      (answers.budget !== 'maximum' || (Number.isFinite(answers.maximum) && answers.maximum > 0 && product.price <= answers.maximum)) &&
      (!answers.shape || answers.shape === 'any' || product.shape === answers.shape);
  }
  function rank(products, answers, currency, alternateFormats) {
    const wanted = (answers.art || []).filter(s => s !== 'any');
    const seen = new Set();
    const eligible = products.filter(p => {
      if (seen.has(p.id) || !hardMatch(p, answers, currency)) return false;
      seen.add(p.id); return true;
    });
    const formatPool = eligible.filter(p => formatMatch(p, answers.format));
    const pool = alternateFormats ? eligible : formatPool;
    const scored = pool.map((p, order) => ({ product: p, order, styleMatches: styles(p).filter(s => wanted.includes(s)), formatMatch: formatMatch(p, answers.format) }));
    scored.sort((a,b) => Number(b.formatMatch)-Number(a.formatMatch) || b.styleMatches.length-a.styleMatches.length || (answers.budget==='value' ? a.product.price-b.product.price : 0) || a.order-b.order);
    let chosen = scored;
    if (wanted.length && scored.some(p => p.styleMatches.length)) chosen = scored.filter(p => p.styleMatches.length);
    // Preserve relevance while presenting each project format before repeats.
    const diversify = (entries, group) => {
      const first=[], rest=[], seenGroups=new Set();
      for(const entry of entries){const key=group(entry.product);(seenGroups.has(key)?rest:first).push(entry);seenGroups.add(key);}
      return first.concat(rest);
    };
    if (answers.format === 'any' || answers.format === 'canvas_all' || answers.format === 'craft') {
      chosen=diversify(chosen,p=>p.format==='canvas'?'canvas-'+(p.sizeBand||'unclassified'):p.format==='craft'?'craft-'+p.projectType:p.format);
      if(answers.format==='any') chosen=diversify(chosen,p=>p.format);
    }
    return { items: chosen.slice(0,4), otherFormatsAvailable: eligible.length > formatPool.length, styleFallback: wanted.length > 0 && chosen.length > 0 && !chosen.some(p=>p.styleMatches.length), totalEligible: eligible.length };
  }
  const api = { styles, hardMatch, rank, catalogScope, formatMatch };
  if (typeof module !== 'undefined' && module.exports) module.exports = api;
  else root.DACBeginnerQuiz = api;
})(typeof window === 'undefined' ? globalThis : window);
